// Mock data for development - will be replaced with .env values

// Fallback testimonials if .env parsing fails
const fallbackTestimonials = [
  { name: 'Ravi Sharma', role: 'Founder', company: 'FinAcc Solutions', review: 'TallyBharat Cloud made our accounting remote-ready and reliable. The automated backups give us complete peace of mind.', rating: 5 },
  { name: 'Sneha Patel', role: 'Finance Head', company: 'Nexora Tech', review: 'Excellent uptime and accessibility from anywhere. Our team can now work from multiple locations seamlessly.', rating: 5 },
  { name: 'Vikas Mehta', role: 'CEO', company: 'Mehta & Co.', review: 'Enhanced workflow efficiency and responsiveness. TallyBharat has transformed how we manage our finances.', rating: 5 },
  { name: 'Neha Gupta', role: 'Accountant', company: 'Aryan Textiles', review: 'Smooth demo experience and easy to use platform. The support team is always helpful and responsive.', rating: 5 },
  { name: 'Saurabh Jain', role: 'CFO', company: 'VServe Group', review: 'Professional and secure — great for finance teams. The multi-user access feature is a game-changer.', rating: 5 },
  { name: 'Rajesh Kumar', role: 'Finance Head', company: 'Kumar Traders Pvt Ltd', review: 'TallyBharat transformed our accounting operations. Cloud hosting is seamless and the automated backups give us peace of mind.', rating: 5 },
  { name: 'Priya Sharma', role: 'Managing Director', company: 'Sharma Enterprises', review: 'Excellent service and support. Our team can now access Tally from anywhere. The multi-user setup works perfectly.', rating: 5 },
  { name: 'Amit Patel', role: 'CA', company: 'Patel & Associates', review: 'As a chartered accountant, I recommend TallyBharat to all my clients. Reliable, secure, and cost-effective solution.', rating: 5 }
];

// Fallback client logos if .env parsing fails
const fallbackLogos = [
  { name: 'Tally Solutions', logo: 'https://tally-bharat.s3.ap-south-1.amazonaws.com/tb-logo.png' },
  { name: 'Partner 1', logo: 'https://tally-bharat.s3.ap-south-1.amazonaws.com/tb-logo.png' },
  { name: 'Partner 2', logo: 'https://tally-bharat.s3.ap-south-1.amazonaws.com/tb-logo.png' },
  { name: 'Partner 3', logo: 'https://tally-bharat.s3.ap-south-1.amazonaws.com/tb-logo.png' },
  { name: 'Partner 4', logo: 'https://tally-bharat.s3.ap-south-1.amazonaws.com/tb-logo.png' },
  { name: 'Partner 5', logo: 'https://tally-bharat.s3.ap-south-1.amazonaws.com/tb-logo.png' },
  { name: 'Partner 6', logo: 'https://tally-bharat.s3.ap-south-1.amazonaws.com/tb-logo.png' },
  { name: 'Partner 7', logo: 'https://tally-bharat.s3.ap-south-1.amazonaws.com/tb-logo.png' }
];

export const getTestimonials = () => {
  try {
    const envTestimonials = process.env.REACT_APP_TESTIMONIALS;
    if (envTestimonials) {
      const parsed = JSON.parse(envTestimonials);
      if (parsed && parsed.length > 0) {
        return parsed;
      }
    }
  } catch (error) {
    console.warn('Failed to parse REACT_APP_TESTIMONIALS:', error);
  }
  return fallbackTestimonials;
};

export const getClientLogos = () => {
  try {
    const envLogos = process.env.REACT_APP_CLIENT_LOGOS;
    if (envLogos) {
      const parsed = JSON.parse(envLogos);
      if (parsed && parsed.length > 0) {
        return parsed;
      }
    }
  } catch (error) {
    console.warn('Failed to parse REACT_APP_CLIENT_LOGOS:', error);
  }
  return fallbackLogos;
};

export const contactInfo = {
  email: process.env.REACT_APP_EMAIL || 'info@tallybharat.com',
  phone1: process.env.REACT_APP_PHONE_1 || '+91 9829055959',
  phone2: process.env.REACT_APP_PHONE_2 || '+91 8094300200',
  address: process.env.REACT_APP_ADDRESS || 'Block H, Boranada Industrial Area, Jodhpur - 342001',
  supportHours: process.env.REACT_APP_SUPPORT_HOURS || 'Mon–Sat, 10 AM – 7 PM'
};

export const pricingPlans = [
  {
    name: 'Basic',
    price: '₹999',
    period: '/month',
    users: '1 User',
    features: [
      'Secure Cloud Access',
      'Auto Tally Updates',
      'Google Drive Backup',
      'Chat Support',
      '99.5% Uptime SLA'
    ],
    highlighted: false
  },
  {
    name: 'Business',
    price: '₹3,499',
    period: '/month',
    users: '5 Users',
    features: [
      'Everything in Basic',
      'Multi-User Access',
      'File & Folder Management',
      'Audit Logs & Activity Tracking',
      'Priority Support',
      'Custom Tally Versions'
    ],
    highlighted: true
  },
  {
    name: 'Virtual Private Server',
    price: '₹53,793',
    period: '/year',
    users: 'Self-managed',
    features: [
      'Dedicated Virtual Server',
      'Full Root Access',
      'Unlimited Users',
      'Custom Configuration',
      '24/7 Server Support',
      'One-time Setup'
    ],
    highlighted: false
  }
];

export const services = [
  {
    title: 'Tally Multi-User Hosting',
    description: 'Access Tally from anywhere with secure cloud hosting. Perfect for teams working remotely.',
    icon: 'Cloud',
    features: ['Multi-user access', 'Real-time sync', 'Auto backups', '99.5% uptime']
  },
  {
    title: 'Raw Windows Server',
    description: 'Get complete control with dedicated Windows server. Ideal for enterprises with specific needs.',
    icon: 'Server',
    features: ['Full root access', 'Custom setup', 'Scalable resources', 'Managed support']
  },
  {
    title: 'Auto Google Drive Backup',
    description: 'Automated daily backups to your Google Drive. Never worry about data loss again.',
    icon: 'HardDrive',
    features: ['Daily auto backup', 'Version control', 'Easy restore', 'Secure encryption']
  },
  {
    title: 'File & Folder Management',
    description: 'Intuitive web panel to manage your Tally files and folders efficiently.',
    icon: 'FolderOpen',
    features: ['Web-based panel', 'Easy navigation', 'Quick access', 'Organized structure']
  },
  {
    title: 'Auto Tally Release Updates',
    description: 'Stay up-to-date with automatic Tally version updates. Always run the latest features.',
    icon: 'RefreshCw',
    features: ['Auto updates', 'Zero downtime', 'Latest features', 'Security patches']
  },
  {
    title: 'Audit Logs & Activity Tracking',
    description: 'Complete visibility of user activities with detailed audit logs and reports.',
    icon: 'FileText',
    features: ['User tracking', 'Activity logs', 'Compliance ready', 'Detailed reports']
  }
];

export const features = [
  {
    title: 'High-Speed Cloud Infrastructure',
    description: 'Lightning-fast servers with 99.5% uptime guarantee',
    icon: 'Zap'
  },
  {
    title: 'Automated Backups',
    description: 'Daily Google Drive sync - your data is always safe',
    icon: 'Shield'
  },
  {
    title: 'Multi-User Access',
    description: 'Work from anywhere, anytime with your team',
    icon: 'Users'
  },
  {
    title: 'Tally Version Control',
    description: 'Change Tally version anytime to suit your needs',
    icon: 'RefreshCw'
  }
];

export const stats = [
  { value: '2000+', label: 'Happy Customers' },
  { value: '99.5%', label: 'Uptime SLA' },
  { value: '21+', label: 'Years Experience' },
  { value: '24/7', label: 'Support Available' }
];

export const partnerBenefits = [
  {
    title: 'Dedicated Partner Support',
    description: 'Personal account manager for all your client needs and technical queries',
    icon: 'UserCheck'
  },
  {
    title: 'Unlimited Markups',
    description: 'Set your own pricing with no restrictions on profit margins',
    icon: 'TrendingUp'
  },
  {
    title: 'Instant Client Onboarding',
    description: 'Get your clients live within hours with our streamlined process',
    icon: 'Rocket'
  },
  {
    title: '24/7 Partner Assistance',
    description: 'Round-the-clock technical and sales support exclusively for partners',
    icon: 'Headphones'
  },
  {
    title: 'Marketing & Sales Boost',
    description: 'Co-branded materials, lead generation support, and promotional tools',
    icon: 'Megaphone'
  },
  {
    title: 'Expert Training & Resources',
    description: 'Comprehensive product training, documentation, and ongoing education',
    icon: 'GraduationCap'
  }
];

export const deals = [
  {
    title: 'Startup Bundle',
    description: 'Perfect for new businesses starting their accounting journey',
    price: '₹999/month',
    features: ['1 User', 'Basic Support', 'Auto Backups', 'Cloud Access'],
    badge: 'Popular'
  },
  {
    title: 'Growth Bundle',
    description: 'Ideal for growing teams that need advanced features',
    price: '₹3,499/mo',
    features: ['5 Users', 'Priority Support', 'Audit Logs', 'File Management'],
    badge: 'Best Value'
  },
  {
    title: 'Enterprise Bundle',
    description: 'Complete solution for large organizations',
    price: 'Custom',
    features: ['Unlimited Users', 'Dedicated Server', 'Custom Setup', '24/7 Support'],
    badge: 'Premium'
  }
];